import { platformSettingRegistrations } from '@crest/platform-configuration/definitions';
import { platformModuleManifest } from '@crest/platform-contracts/modules';
import { platformMyDayHostCapability, platformMyDayHostSlots } from '@crest/platform-contracts/hosts';
export const platformWebModuleContribution = {
    moduleId: 'platform',
    manifest: platformModuleManifest,
    settingRegistrations: platformSettingRegistrations,
    settingEditors: [
        {
            id: 'platform.web.settings.theme-tokens',
            moduleId: 'platform',
            settingKey: 'platform.theme.tokens',
            priority: 0,
            load: () => import('./configuration/platform-theme-tokens-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.branding-identity',
            moduleId: 'platform',
            settingKey: 'platform.branding.identity',
            priority: 10,
            load: () => import('./configuration/platform-branding-identity-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.custom-domains',
            moduleId: 'platform',
            settingKey: 'platform.custom-domains.selection',
            priority: 20,
            load: () => import('./configuration/platform-custom-domain-selection-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.sender-identities',
            moduleId: 'platform',
            settingKey: 'platform.sender-identities.selection',
            priority: 30,
            load: () => import('./configuration/platform-sender-identity-selection-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.shell-layout',
            moduleId: 'platform',
            settingKey: 'platform.layout.shell',
            priority: 40,
            load: () => import('./configuration/platform-shell-layout-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.accessibility-preferences',
            moduleId: 'platform',
            settingKey: 'platform.accessibility.preferences',
            priority: 50,
            load: () => import('./configuration/platform-accessibility-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.core-copy',
            moduleId: 'platform',
            settingKey: 'platform.copy.core',
            priority: 60,
            load: () => import('./configuration/platform-core-copy-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.my-day-copy',
            moduleId: 'platform',
            settingKey: 'platform.copy.my-day',
            priority: 70,
            load: () => import('./configuration/platform-my-day-copy-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.system-notification-configuration',
            moduleId: 'platform',
            settingKey: 'platform.system-notifications.configuration',
            priority: 80,
            load: () => import('./configuration/platform-system-notification-configuration-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.system-notification-display',
            moduleId: 'platform',
            settingKey: 'platform.system-notifications.display',
            priority: 90,
            load: () => import('./configuration/platform-system-notification-display-setting-editor.js'),
        },
        {
            id: 'platform.web.settings.system-notification-copy',
            moduleId: 'platform',
            settingKey: 'platform.copy.system-notifications',
            priority: 100,
            load: () => import('./configuration/platform-system-notification-copy-setting-editor.js'),
        },
    ],
    hostContracts: [{
            capability: platformMyDayHostCapability,
            slots: Object.values(platformMyDayHostSlots),
        }],
    hostContributions: [],
    routes: [{
            id: 'platform.web.my-day',
            moduleId: 'platform',
            path: '/my-day',
            requiredPermission: 'platform.runtime.read',
            navigation: {
                id: 'platform.navigation.my-day',
                fallbackLabel: 'My Day',
                labelConfigurationKey: 'platform.copy.my-day',
                labelValueProperty: 'navigationLabel',
                priority: 0,
            },
            load: () => import('./my-day/platform-my-day.page.js'),
        }],
};
//# sourceMappingURL=platform-web.module-contribution.js.map